// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Uzbekistan from '../_raw/flag/icon_flag_uzbekistan.png';

export default () => <img src={Uzbekistan} alt="Uzbekistan" />;
